import { render, staticRenderFns } from "./tab-others.vue?vue&type=template&id=b52bb58e&scoped=true"
import script from "./tab-others.vue?vue&type=script&lang=js"
export * from "./tab-others.vue?vue&type=script&lang=js"
import style0 from "./tab-others.vue?vue&type=style&index=0&id=b52bb58e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52bb58e",
  null
  
)

export default component.exports